module.exports = __webpack_public_path__ + "img/culture_active4.40e40594.png";